/* eslint-disable @next/next/no-img-element */
import React from "react";
import NavItem from "./NavItem";
import Image from "next/legacy/image";
import Link from "next/link";
import NavActions from "@src/auth/components/UserButton";
import { getEnvironment } from "@src/common/utils/environment";

type Props = {
  children: React.ReactNode;
};

function NavComponent({ children }: Props) {
  const environment = getEnvironment();

  const getLogoFilter = (): string => {
    switch (environment) {
      case "local":
        return "hue-rotate(-150deg)"; // Convert orange to blue
      case "development":
        return "hue-rotate(270deg)"; // Convert orange to purple
      case "production":
        return "";
    }
  };

  const getLogoText = (): React.ReactNode => {
    var text = "";
    switch (environment) {
      case "local":
        text = "Local";
        break;
      case "development":
        text = "DEV";
        break;
      case "production":
        return null;
    }
    return (
      <span
        className="text-[10px] font-mono font-bold rounded-full px-1 py-0.5 absolute bottom-0 right-0
          bg-gray-200/75 dark:bg-gray-700/75 border border-gray-300 dark:border-gray-600 text-gray-500 dark:text-gray-400"
      >
        {text}
      </span>
    );
  };

  return (
    <nav className="relative flex w-full items-center">
      <div className="navbar-left-content">
        <Link
          href="/deliveries/orders"
          className="ml-2 flex items-center p-2 rounded-full hover:bg-slate-200 dark:hover:bg-gray-700 transition ease-in-out delay-75 relative"
        >
          <Image
            src={"/courielogo.png"}
            alt="Logo"
            width={30}
            height={30}
            style={{ filter: getLogoFilter() }}
          />
          {getLogoText()}
        </Link>
      </div>
      <div className="absolute left-1/2 transform -translate-x-1/2 flex">
        {children}
      </div>
      <div className="flex gap-2 items-center h-full ml-auto">
        <NavActions />
      </div>
    </nav>
  );
}

export const Nav = { Group: NavComponent, Item: NavItem };
